<template>
  <div class="detail">
    <div class="header">
      <div>
        工单信息
        <span v-if="workOrderInfo.workOrder.businessType == 33">
          ({{
            followBusinessType == 1
              ? `医生:${workOrderInfo.workOrder.ucDoctorName}`
              : `患者:${workOrderInfo.workOrder.ucPatientName}`
          }})
        </span>
      </div>
      <div v-if="workOrderInfo.workOrder.patientId" class="patient_info" @click="handlePatientFile">
        查看患者信息
      </div>
    </div>
    <div class="detail_label">
      <div
        class="detail_label_info"
        v-for="item in workorderDetailConfig"
        :key="item.label"
        :class="item.class"
      >
        <span class="item_label">{{ item.label }}</span>
        <span v-if="item.prop === 'workOrderStatusDesc'" class="item_content">
          {{ workOrderInfo.workOrder.workOrderStatusDesc
          }}{{
            workOrderInfo.workOrder.stateTagDesc ? `——` + workOrderInfo.workOrder.stateTagDesc : ''
          }}
        </span>
        <span v-else-if="item.prop === 'workOrderTask'">
          <!-- 临观标签 -->
          <auth-img
            src="@/assets/img/work-place/lin-guan.png"
            alt="临观标签"
            v-if="workOrderInfo.workOrder.activityFlag"
            style="margin-right: 4px"
          />
          <div
            @click="toPreDetail(workOrderInfo.workOrder.serialNumber)"
            v-html="
              brightenKeyword(
                workOrderInfo.workOrder.workOrderTask,
                workOrderInfo.workOrder.serialNumber
              )
            "
          ></div>
        </span>
        <span v-else-if="item.prop === 'isValid'" class="item_content">
          {{ orderIsValid(workOrderInfo.workOrder.isValid) }}
        </span>
        <span v-else-if="item.prop === 'rollbackNumber'" class="item_content">
          {{
            workOrderInfo.workOrder.rollbackNumber || workOrderInfo.workOrder.rollbackNumber === 0
              ? workOrderInfo.workOrder.rollbackNumber
              : '--'
          }}
        </span>
        <span v-else-if="item.prop === 'notBuyReason'" class="item_content">
          <template v-if="workOrderInfo.workOrder.notBuyReason === 5">
            其他原因：{{ workOrderInfo.workOrder.notBuyOtherReason || '--' }}
          </template>
          <template v-else>
            {{ workOrderInfo.workOrder.notBuyReason || '--' }}
          </template>
        </span>
        <span v-else class="item_content">
          {{ workOrderInfo.workOrder[`${item.prop}`] || '--' }}
        </span>
      </div>
      <!-- 根据工单类型是否显示的类型 -->
      <div
        v-for="item in businessTypeLabels"
        :key="item.label"
        class="detail_label_info"
        :class="item.class"
      >
        <span class="item_label">{{ item.label }}</span>
        <span class="item_content" v-if="item.prop === 'followRecordNextTime'">
          {{
            workOrderInfo?.requireFollowDetailVO.unFollowRecord !== 1
              ? workOrderInfo?.requireFollowDetailVO[`${item.prop}`] || '--'
              : '--'
          }}
        </span>
        <span class="item_content" v-else-if="item.prop === 'unRevisitReasonStr'">
          {{ workOrderInfo?.workOrder[`${item.prop}`] || '--' }}
        </span>
        <span class="item_content" v-else>
          {{ workOrderInfo?.requireFollowDetailVO[`${item.prop}`] || '--' }}
        </span>
      </div>
    </div>
    <div class="logs">工单日志</div>
    <div class="logs_table">
      <a-table
        :columns="workorderLogs"
        :data-source="workOrderInfo.logList"
        :rowKey="(record, index) => index"
        :pagination="false"
      >
        <template #operateActionDesc="{ record, text: operateActionDesc }">
          <span class="numLink" @click="handleOperateTrace(record)">
            {{ operateActionDesc }}
          </span>
        </template>
      </a-table>
    </div>
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
      mode="read"
    />
  </div>
</template>
<script setup>
import TheDetail from '@/components/TheDetail/index.vue'
import { workorderDetailConfig, workorderLogs, labelByTypeDetailConfig } from './config'
import { defineProps, ref, reactive, defineEmits, watch, computed } from 'vue'
import { workOrderDetail, getSubTaskDetail } from '@/api/Todo/index.js'
import { subStringToType } from '@/utils/index'
import { SHOW_FOLLOWUP_TAB } from '@/components/PatientInfoDetails/eventBuss.js'
import store from '@/store'
const props = defineProps({
  workOrderId: {
    type: [String, Number],
    default: ''
  },
  followBusinessType: {
    type: Number,
    default: null
  },
  id: {
    type: String,
    default: ''
  }
})
const detail = reactive({
  detailVisible: false,
  serialNumber: '',
  recordType: ''
})
const workOrderInfo = ref({
  workOrder: {},
  requireFollowDetailVO: {},
  logList: []
})

const businessTypeLabels = computed(() => {
  return labelByTypeDetailConfig.filter(item => {
    return item.showBusinessType.includes(workOrderInfo.value.workOrder.businessType)
  })
})

watch(
  () => [props.workOrderId, props.id],
  ([newWorkOrderId, newSonId]) => {
    console.log('newWorkOrderId', newWorkOrderId, newSonId)
    newSonId ? subTaskDetail() : newWorkOrderId && getWorkOrderDetails()
  },
  { immediate: true }
)

function getWorkOrderDetails() {
  if (props.id) return
  workOrderDetail({ workOrderId: props.workOrderId })
    .then(res => {
      const { workOrder = {}, logList = [], requireFollowDetailVO = {} } = res || {}
      workOrderInfo.value = {
        workOrder,
        logList,
        requireFollowDetailVO: requireFollowDetailVO || {}
      }
      SHOW_FOLLOWUP_TAB?.emit(res?.workOrder?.insideHospitalFlag || false)
      store.commit('workOrder/SET_WORK_ORDER_DETAILS', {
        key: `${workOrder?.workOrderId}`,
        value: res
      })
    })
    .finally(() => {
      emit('orderFinish')
    })
}

// 查看患者信息
const handlePatientFile = () => {
  const param = {
    patientId: workOrderInfo.value.workOrder?.patientId,
    patientType: 1,
    doctorId: workOrderInfo.value.workOrder?.doctorId
  }
  store.dispatch('patientFile/openModal', param)
}

// 复诊提醒工单子工单详情
function subTaskDetail() {
  getSubTaskDetail({
    subTaskId: props.id,
    followBusinessType: props.followBusinessType
  })
    .then(res => {
      const { workOrder = {}, logList = [] } = res || {}
      workOrderInfo.value = {
        workOrder,
        logList
      }
      SHOW_FOLLOWUP_TAB.emit(res?.workOrder?.insideHospitalFlag || false)
      store.commit('workOrder/SET_WORK_ORDER_DETAILS', {
        key: `${workOrder?.workOrderId}`,
        value: res
      })
    })
    .finally(() => {
      emit('orderFinish')
    })
}

const brightenKeyword = (val, keyword) => {
  const Reg = new RegExp(keyword, 'i')
  let res = val
  if (val) {
    res = val.replace(Reg, `<span style="color: #1890FF;cursor:pointer; ">${keyword}</span>`)
  }
  return res
}
const toPreDetail = serialNumber => {
  if (!serialNumber) return
  detail.serialNumber = serialNumber
  detail.recordType = subStringToType(serialNumber)
  detail.detailVisible = true
}

const orderIsValid = isValid => {
  if (isValid === null) return '--'
  return isValid ? '有效' : '无效'
}

const emit = defineEmits(['emitTrace', 'orderFinish'])
const handleOperateTrace = record => {
  emit('emitTrace', record)
}
</script>
<style scoped lang="scss">
.detail {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  padding: 2px 6px;
  .header {
    display: flex;
    justify-content: space-between;
    .patient_info {
      border-radius: 4px;
      background: #1890ff;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      padding: 8px 12px;
      cursor: pointer;
    }
  }
  .detail_label {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(2, minmax(44px, auto));
    list-style: none;
    margin: 0;
    padding-left: 0;
    // grid-gap: 5px 0;
    position: relative;
    margin-bottom: 30px;

    &_info {
      &.large {
        // 左边框所在网格线
        grid-column-start: 1;
        // 右边框所在网格线
        grid-column-end: 4;
      }
      &.extra {
        // 左边框所在网格线
        grid-column-start: 2;
        // 右边框所在网格线
        grid-column-end: 4;
      }
      font-size: 14px;
      padding: 20px 0 20px 16px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      // 第一列左对齐
      &.nopadding {
        padding-left: 0;
      }
      // 最后一列不要边框
      &.noborder .item_content:after {
        width: 0;
      }
      &.nobottom {
        border-bottom: 0;
      }
      .item_label {
        font-weight: 550;
        flex-shrink: 0;
        margin-right: 3px;
        color: #999999;
      }
      .item_content {
        font-weight: 400;
        color: #666666;
        flex: auto;
        width: 80%;
        z-index: 2;
        font-weight: bold;
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 1px;
          background: #e8e8e8;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }
  .logs {
    padding: 12px 0;
    border-bottom: 1px solid #e8e8e8;
  }

  .numLink {
    cursor: pointer;
    color: #1890ff;
  }
  .numLink:hover {
    color: #40a9ff;
  }
}
</style>
